import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../../../../store/modules/journals";
import * as FActions from "../../../../../../../store/modules/footer";

import DropdownTreeSelect from "react-dropdown-tree-select";
import * as func from "../../../../../../../utils/functions";

class JournalCategory extends Component {
	constructor(props) {
		super(props);

		let categoryIds = [];
		this.props.category.map((c, i) => {
			categoryIds.push(c.category_id)
		});

		this.state = {
			category: [],
			param: {
				query: ''
			},
			category_id: [],
			record_id: this.props.record_id,
			isInit: false
		}

		func.getData("category/" + this.props.type, this.state.param).then((response) => {
			const t = {};
			t.category = [];
			t.isInit = true;
			response.records.map((r, i) => {
				let temp = {
					label: r.category_name,
					value: r.category_id
				}
				if (categoryIds.includes(temp.value)) {
					temp.checked = true;
				}
				t.category.push(temp)
			});

			this.setState(t);
		});

		this.onChange = this.onChange.bind(this);
	}

	onChange(currentNode, selectedNodes) {
		if (this.props.depth) {
			let category_id = [];
			selectedNodes.map((r, i) => {
				category_id.push(r.value)
			});
			func.getData("admin/category/update", {
				record_id: this.state.record_id,
				category_id: category_id,
				type: this.props.type
			}).then((response) => {
				this.props.showMessage('수정 되었습니다.');
			});
		} else {
			if (currentNode.checked) {
				// 추가
				func.getData("admin/category/insert", {
					record_id: this.state.record_id,
					category_id: currentNode.value
				}).then((response) => {
					this.props.showMessage('추가 되었습니다.');
				});
			} else {
				// 삭제
				func.getData("admin/category/delete", {
					record_id: this.state.record_id,
					category_id: currentNode.value
				}).then((response) => {
					this.props.showMessage('삭제 되었습니다.');
				});
			}
		}
	}

	render() {
		if (!this.state.isInit)
			return '';

		return (
			<>
				<div className="card-header">
					{this.props.title}
				</div>
				<div className="card-body adminCatSelectBox">
					<DropdownTreeSelect
						data={this.state.category}
						keepTreeOnSearch={true}
						keepChildrenOnSearch={true}
						keepOpenOnSelect={true}
						onChange={this.onChange}
						onAction={this.onAction} onNodeToggle={this.onNodeToggle}
					/>
				</div>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JournalCategory)
